export default __webpack_public_path__ + "static/media/diamond-color-table.ba40c16b.png";